var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-result-box"},[(_vm.form[_vm.componentKey] == 1)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("成功")]):(_vm.form[_vm.componentKey] == 2)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("失败")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }